module.exports = __webpack_public_path__ + "97bd144a19a2d4dee0ade6ffe2119a1b.png";